<template>
  <div
    class="ma-0 pa-0"
  >
    <div
      v-for="(s, i) in fees"
      :key="i"
      class="d-md-flex"
    >
      <v-flex
        pl-md-0
        xs12
        md2
      >
        <v-text-field
          v-model.trim.number="fees[i].min_balance"
          :error-messages="min_balance_errors[i]"
          :label="$t('globals.minBalance')+'*'"
          type="number"
          required
          @input="validateField('min_balance', i)"
          @blur="validateField('min_balance', i)"
        >
          <template v-slot:append>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">
                  mdi-information-outline
                </v-icon>
              </template>
              {{ $t('projects.minBalanceTooltip') }}
            </v-tooltip>
          </template>
        </v-text-field>
      </v-flex>
      <v-flex
        xs12
        md2
      >
        <v-text-field
          v-model.trim.number="fees[i].max_balance"
          :error-messages="max_balance_errors[i]"
          :label="$t('globals.maxBalance')+'*'"
          type="number"
          required
          @input="validateField('max_balance', i)"
          @blur="validateField('max_balance', i)"
        >
          <template v-slot:append>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">
                  mdi-information-outline
                </v-icon>
              </template>
              {{ $t('projects.maxBalanceTooltip') }}
            </v-tooltip>
          </template>
        </v-text-field>
      </v-flex>
      <v-flex
        xs12
        md2
      >
        <v-text-field
          v-model.trim.number="fees[i].management_fee"
          :error-messages="management_fee_errors[i]"
          :label="$t('globals.managementFee')+'*'"
          type="number"
          suffix="%"
          required
          @input="validateField('management_fee', i)"
          @blur="validateField('management_fee', i)"
        >
          <template v-slot:append>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">
                  mdi-information-outline
                </v-icon>
              </template>
              {{ $t('projects.managementFeeTooltip') }}
            </v-tooltip>
          </template>
        </v-text-field>
      </v-flex>
      <v-flex
        xs12
        md2
      >
        <v-text-field
          v-model.trim.number="fees[i].referral_fee"
          :error-messages="referral_fee_errors[i]"
          :label="$t('globals.referralFee')+'*'"
          type="number"
          suffix="%"
          required
          @input="validateField('referral_fee', i)"
          @blur="validateField('referral_fee', i)"
        >
          <template v-slot:append>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">
                  mdi-information-outline
                </v-icon>
              </template>
              {{ $t('projects.referralFeeTooltip') }}
            </v-tooltip>
          </template>
        </v-text-field>
      </v-flex>
      <v-flex
        xs12
        md2
        pr-md-0
        pb-0
        pb-md-2
      >
        <v-text-field
          v-model.trim.number="fees[i].trader_fee"
          :error-messages="trader_fee_errors[i]"
          :label="$t('globals.traderFee')+'*'"
          type="number"
          suffix="%"
          required
          @input="validateField('trader_fee', i)"
          @blur="validateField('trader_fee', i)"
        >
          <template v-slot:append>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">
                  mdi-information-outline
                </v-icon>
              </template>
              {{ $t('projects.traderFeeTooltip') }}
            </v-tooltip>
          </template>
        </v-text-field>
      </v-flex>
      <v-flex
        xs12
        md1
        mt-xs-0
        pt-md-7
        pl-md-5
      >
        <div>
          <v-icon
            v-if="i > 0"
            class="float-right"
            @click="remove(i)"
          >
            mdi-bucket-outline
          </v-icon>
        </div>
      </v-flex>
    </div>
    <div v-if="fees.length <= 10">
      <v-flex
        mt-0
        ml-0
        pt-0
        pl-0
        mb-5
      >
        <v-btn
          outlined
          text
          small
          @click="addMore"
        >
          {{ $t('globals.addMoreButton') }}
        </v-btn>
      </v-flex>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import {
  required,
  requiredIf,
  forEach,
  between
} from "vuelidate/lib/validators";

export default {
name: "FeeStructure",
  mixins: [validationMixin],
  props: {
    feeStructure: {
      type: Array,
      default: () =>([])
    }
  },
  data() {
    return {
      fees: [],
      structure: {
        min_balance: 0,
        max_balance: 0,
        management_fee: 0,
        referral_fee: 0,
        trader_fee: 0
      },
      rulesStrucure: {
        min_balance: {
          required,
        },
        max_balance: {
          required,
        },
        management_fee: {
          required,
          between: between(0, 100)
        },
        referral_fee: {
          required,
          between: between(0, 100)
        },
        trader_fee: {
          required,
          between: between(0, 100)
        },
      },
      min_balance_errors: [],
      max_balance_errors: [],
      management_fee_errors: [],
      referral_fee_errors: [],
      trader_fee_errors: []
    }
  },
  validations() {
    return {
      fees: {
        $each: {
          min_balance: {
            required,
          },
          max_balance: {
            required,
          },
          management_fee: {
            required,
            between: between(0, 100)
          },
          referral_fee: {
            required,
            between: between(0, 100)
          },
          trader_fee: {
            required,
            between: between(0, 100)
          },
        }
      }
    }
  },
  mounted() {
    if (this.feeStructure.length > 0) {
       this.fees = this.feeStructure
    } else {
      this.fees.push(JSON.parse(JSON.stringify(this.structure)))
    }
  },
  methods: {
    addMore() {
      this.fees.push(JSON.parse(JSON.stringify(this.structure)))
    },
    remove(index) {
      this.fees.splice(index, 1)
    },
    validateField(field, i) {
      this.$v.fees.$each[i][field].$touch()
      this.$v.fees.$each[i][field].$touch()
      const errors = [];
       
      if (!this.$v.fees.$each[i][field].$dirty) {
        return
      }
      
      !this.$v.fees.$each[i][field].required &&
        errors.push(this.$t("projects.reqField"));
      
      if (field == 'management_fee' || field == 'referral_fee' || field == 'trader_fee') {
        !this.$v.fees.$each[i][field].between &&
        errors.push(this.$t("projects.0100Field"));
      }  
      this[field+'_errors'][i] = errors
      this.$emit("onUpdate", this.fees);
    },
  }
}    
</script>